import { render, staticRenderFns } from "./LiveCourses.vue?vue&type=template&id=31b1387b&scoped=true"
import script from "./LiveCourses.vue?vue&type=script&lang=js"
export * from "./LiveCourses.vue?vue&type=script&lang=js"
import style0 from "./LiveCourses.vue?vue&type=style&index=0&id=31b1387b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b1387b",
  null
  
)

export default component.exports